export class SchoolDocumentFile {

    constructor(
        public name: string,
        public id?: number | null
    ){}
}
